export const numbersRange = (start: number, stop: number, step: number = 1): number[] =>
Array.from(
	{ length: (stop - start) / step + 1 },
	(value, index) => start + index * step
);